/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAccountMetricsConfig } from '../models/RestoreAccountMetricsConfig';

export class EnableRestoreAccountMetricsConfigResponse {
  'restoreAccountConfig': RestoreAccountMetricsConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountConfig",
      "baseName": "restoreAccountConfig",
      "type": "RestoreAccountMetricsConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EnableRestoreAccountMetricsConfigResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

